export default __webpack_public_path__ + "static/scARf3-fbedf98fd9d38168daa92c79a6a9af6d.jpg";